module.exports = __webpack_public_path__ + "static/media/bg.c00ac42c.png";